var _defs, _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFeedback = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{ fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 24,
  height: 24
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M16.414,6.586A3.415,3.415,0,0,0,12,6.232a3.414,3.414,0,0,0-4.414,5.182l3,3a2,2,0,0,0,2.828,0l3-3A3.414,3.414,0,0,0,16.414,6.586ZM9,8a1.414,1.414,0,0,0,0,2l3,3,3-3a1.414,1.414,0,1,0-2-2L12,9,11,8A1.414,1.414,0,0,0,9,8Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M18,18H8L3.555,20.963A1,1,0,0,1,2,20.132V6A4,4,0,0,1,6,2H18a4,4,0,0,1,4,4v8A4,4,0,0,1,18,18ZM8,16a2,2,0,0,0-1.109.336L4,18.263V6A2,2,0,0,1,6,4H18a2,2,0,0,1,2,2v8a2,2,0,0,1-2,2Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFeedback, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-feedback.ab901d27.svg";
export { ForwardRef as ReactComponent };